import { ConvexError } from "convex/values";

export function projectDocumentErrorMessage(error: unknown) {
  if (error instanceof ConvexError && typeof error.data === "string") return error.data;
  if (error instanceof Error && !error.message.includes("[CONVEX")) return error.message;
  return "Não foi possível atualizar o documento. Tente novamente.";
}
